import { Role } from '@therame/shared';

export const getIndexPathForRole = (role: Role) => {
  switch (role) {
    case Role.ADMIN:
    case Role.THERAPIST:
    case Role.MANAGEMENT:
    case Role.PATIENT:
      return '/';
    // The Versand-Operator (#1612) has no location and no practice navigation;
    // their start page is the work list.
    case Role.TRANSMISSION_OPERATOR:
      return '/versand/identitaet';
    default:
      return '/404';
  }
};
